<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      :text="resourceTitle"
      class="mb-0"
      v-if="resourceTitle"
    >
    </ItpText>
    <ItpText
      tag="h5"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <ItpBox
    direction="column"
    v-if="!entry.isNew && entry.invoice"
  >
    <ItpText
      muted
      :text="'Invoice number'|pgettext('RegisterEntryHeader')"
      class="mb-0"
    >
    </ItpText>
    <ItpText
      tag="h4"
      :text="entry.invoice.invoice_number"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <UcRegisterSelector
    :companyId="entry.version.company_id"
    v-model="registerInfo"
    toggleClass="bg-white"
    v-if="entry.isNew && selectRegister"
    @input="evh_8358196963355853_input($event, {})"
  >
  </UcRegisterSelector>
  <h6
    :title="'Locked'|pgettext('ResourceStatus')"
    class="my-0 align-self-center"
    v-if="entry.isReadOnly"
  >
    <span
      class="badge badge-secondary d-inline-flex align-items-center justify-content-start px-2"
      :style="b_6917646200545441_style"
    >
      <ItpIcon
        :icon="$config.lockIcon"
      >
      </ItpIcon>
      <span
        class="ml-1"
      >
        {{ 'Locked'|pgettext('ResourceStatus') }}
      </span>
    </span>
  </h6>
  <h6
    :title="'Void'|pgettext('ResourceStatus')"
    class="my-0 align-self-center"
    v-if="entry.void"
  >
    <span
      class="badge badge-warning d-inline-flex align-items-center justify-content-start px-2"
      :style="b_6424600534600827_style"
    >
      <ItpIcon
        icon="eva:slash-fill"
      >
      </ItpIcon>
      <span
        class="ml-1"
      >
        {{ 'Void'|pgettext('ResourceStatus') }}
      </span>
    </span>
  </h6>
  <b-button-group
    class="ml-auto"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto"
      v-if="!entry.isNew"
      @click.prevent.stop="evh_4576710983066270_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      class="border"
      v-if="!entry.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Lock'|pgettext('BtnLockText')"
        :tooltip="'Lock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_lock"
        @click.prevent.stop="evh_2124730035910225_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Unlock'|pgettext('BtnLockText')"
        :tooltip="'Unlock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_unlock"
        @click.prevent.stop="evh_1972474632001399_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Invalidate'|pgettext('BtnLockText')"
        :tooltip="'Invalidate'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_invalidate"
        @click.prevent.stop="evh_2383909669375364_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Revoke invalidated'|pgettext('BtnLockText')"
        :tooltip="'Revoke invalidated'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!entry.isNew && entry.meta.can_revoke_invalidation"
        @click.prevent.stop="evh_2342151935932928_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="entry"
        :tooltip="'Delete entry'|pgettext('Register')"
        v-if="!entry.isNew && !entry.isReadOnly"
        @success="evh_2498310591257107_success($event, {})"
      >
      </BtnDeleteResource>
    </b-dropdown>
  </b-button-group>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegisterEntryHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  entry!: object;

  @Watch('entry')
  onEntry(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("entry")
  }

  @Prop({
    type: Boolean,
  })
  selectRegister!: boolean;

  @Watch('selectRegister')
  onSelect_register(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("selectRegister")
  }

  messages!: any;
  registerInfo!: any;

  async $$load_registerInfo() {
    return {
      selectedRegisterId: this.entry.version.register_id,
      selectedVersionId: this.entry.version.version_id,
    }
  }

  ux!: any;
  b_6917646200545441_style!: any;
  b_6424600534600827_style!: any;
  dataMembers = ['messages', 'registerInfo', 'ux', 'b_6917646200545441_style', 'b_6424600534600827_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newTransaction: this.$fn.pgettext("Register", "New entry"),
        }
        ,
        registerInfo: null,
        ux: null,
        b_6917646200545441_style: {
          "font-size": "1em",
        }
        ,
        b_6424600534600827_style: {
          "font-size": "1em",
        }
        ,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return !this.selectRegister && this.entry.version.name
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.entry.isNew
        ? this.messages.newTransaction + ` - ${this.entry.entry_number}`
        : this.entry.entry_number
    }
    return null;
  }

  async act_8358196963355853_script_8016_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8358196963355853_script_8016, alias=undefined
    this.$emit('registerChanged', $event.data)
  }

  async act_8358196963355853_script_8016_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8358196963355853_script_8016, alias=undefined
    return {
      value: () => this.act_8358196963355853_script_8016_getActionArgs_value($event),
    }
  }

  async evh_8358196963355853_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8358196963355853_input.executeFromDOM(this, event, scope);
  }

  async act_4576710983066270_emit_8018_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4576710983066270_emit_8018, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_4576710983066270_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4576710983066270_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2124730035910225_emit_8022_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2124730035910225_emit_8022, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_2124730035910225_reloadSlickgrid_8024_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2124730035910225_reloadSlickgrid_8024, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_2124730035910225_request_8020_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2124730035910225_request_8020, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        locked: true,
      },
    }
  }

  async evh_2124730035910225_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2124730035910225_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1972474632001399_emit_8028_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1972474632001399_emit_8028, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_1972474632001399_reloadSlickgrid_8030_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1972474632001399_reloadSlickgrid_8030, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_1972474632001399_request_8026_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1972474632001399_request_8026, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        locked: false,
      },
    }
  }

  async evh_1972474632001399_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1972474632001399_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2383909669375364_emit_8034_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2383909669375364_emit_8034, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_2383909669375364_reloadSlickgrid_8036_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2383909669375364_reloadSlickgrid_8036, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_2383909669375364_request_8032_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2383909669375364_request_8032, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        void: true,
      },
    }
  }

  async evh_2383909669375364_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2383909669375364_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2342151935932928_emit_8040_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2342151935932928_emit_8040, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_2342151935932928_reloadSlickgrid_8042_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2342151935932928_reloadSlickgrid_8042, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_2342151935932928_request_8038_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2342151935932928_request_8038, alias=lock
    return {
      operation: "update_register_entry",
      data: {
        id: this.entry.id,
        etag: this.entry.etag,
        void: false,
      },
    }
  }

  async evh_2342151935932928_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2342151935932928_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2498310591257107_emit_8044_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2498310591257107_emit_8044, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_2498310591257107_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2498310591257107_success.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_8358196963355853_script_8016: actions.ScriptAction;
    evh_8358196963355853_input_8015: actions.EventHandlerImpl;
    evh_8358196963355853_input: actions.EventHandlerGroup;
    act_4576710983066270_emit_8018: actions.EmitAction;
    evh_4576710983066270_clickPreventStop_8017: actions.EventHandlerImpl;
    evh_4576710983066270_clickPreventStop: actions.EventHandlerGroup;
    act_2124730035910225_emit_8022: actions.EmitAction;
    evh_2124730035910225_success_8021: actions.EventHandlerImpl;
    act_2124730035910225_reloadSlickgrid_8024: actions.ReloadSlickgridAction;
    evh_2124730035910225_success_8023: actions.EventHandlerImpl;
    act_2124730035910225_request_8020: actions.RequestAction;
    evh_2124730035910225_clickPreventStop_8019: actions.EventHandlerImpl;
    evh_2124730035910225_clickPreventStop: actions.EventHandlerGroup;
    act_1972474632001399_emit_8028: actions.EmitAction;
    evh_1972474632001399_success_8027: actions.EventHandlerImpl;
    act_1972474632001399_reloadSlickgrid_8030: actions.ReloadSlickgridAction;
    evh_1972474632001399_success_8029: actions.EventHandlerImpl;
    act_1972474632001399_request_8026: actions.RequestAction;
    evh_1972474632001399_clickPreventStop_8025: actions.EventHandlerImpl;
    evh_1972474632001399_clickPreventStop: actions.EventHandlerGroup;
    act_2383909669375364_emit_8034: actions.EmitAction;
    evh_2383909669375364_success_8033: actions.EventHandlerImpl;
    act_2383909669375364_reloadSlickgrid_8036: actions.ReloadSlickgridAction;
    evh_2383909669375364_success_8035: actions.EventHandlerImpl;
    act_2383909669375364_request_8032: actions.RequestAction;
    evh_2383909669375364_clickPreventStop_8031: actions.EventHandlerImpl;
    evh_2383909669375364_clickPreventStop: actions.EventHandlerGroup;
    act_2342151935932928_emit_8040: actions.EmitAction;
    evh_2342151935932928_success_8039: actions.EventHandlerImpl;
    act_2342151935932928_reloadSlickgrid_8042: actions.ReloadSlickgridAction;
    evh_2342151935932928_success_8041: actions.EventHandlerImpl;
    act_2342151935932928_request_8038: actions.RequestAction;
    evh_2342151935932928_clickPreventStop_8037: actions.EventHandlerImpl;
    evh_2342151935932928_clickPreventStop: actions.EventHandlerGroup;
    act_2498310591257107_emit_8044: actions.EmitAction;
    evh_2498310591257107_success_8043: actions.EventHandlerImpl;
    evh_2498310591257107_success: actions.EventHandlerGroup;
  }

  getActions() {
    const act_8358196963355853_script_8016 = new actions.ScriptAction(
      {
        actionArgs: this.act_8358196963355853_script_8016_getActionArgs,
        events: [],
      }
    );
    const evh_8358196963355853_input_8015 = new actions.EventHandlerImpl(
      {
        action: act_8358196963355853_script_8016,
        event: "input",
        displayName: "script",
      }
    );
    const evh_8358196963355853_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_8358196963355853_input_8015],
      }
    );
    const act_4576710983066270_emit_8018 = new actions.EmitAction(
      {
        actionArgs: this.act_4576710983066270_emit_8018_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_4576710983066270_clickPreventStop_8017 = new actions.EventHandlerImpl(
      {
        action: act_4576710983066270_emit_8018,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_4576710983066270_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4576710983066270_clickPreventStop_8017],
      }
    );
    const act_2124730035910225_emit_8022 = new actions.EmitAction(
      {
        actionArgs: this.act_2124730035910225_emit_8022_getActionArgs,
        events: [],
      }
    );
    const evh_2124730035910225_success_8021 = new actions.EventHandlerImpl(
      {
        action: act_2124730035910225_emit_8022,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2124730035910225_reloadSlickgrid_8024 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2124730035910225_reloadSlickgrid_8024_getActionArgs,
        events: [],
      }
    );
    const evh_2124730035910225_success_8023 = new actions.EventHandlerImpl(
      {
        action: act_2124730035910225_reloadSlickgrid_8024,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2124730035910225_request_8020 = new actions.RequestAction(
      {
        actionArgs: this.act_2124730035910225_request_8020_getActionArgs,
        displayName: "lock",
        events: [evh_2124730035910225_success_8021, evh_2124730035910225_success_8023],
      }
    );
    const evh_2124730035910225_clickPreventStop_8019 = new actions.EventHandlerImpl(
      {
        action: act_2124730035910225_request_8020,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_2124730035910225_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2124730035910225_clickPreventStop_8019],
      }
    );
    const act_1972474632001399_emit_8028 = new actions.EmitAction(
      {
        actionArgs: this.act_1972474632001399_emit_8028_getActionArgs,
        events: [],
      }
    );
    const evh_1972474632001399_success_8027 = new actions.EventHandlerImpl(
      {
        action: act_1972474632001399_emit_8028,
        event: "success",
        displayName: "emit",
      }
    );
    const act_1972474632001399_reloadSlickgrid_8030 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1972474632001399_reloadSlickgrid_8030_getActionArgs,
        events: [],
      }
    );
    const evh_1972474632001399_success_8029 = new actions.EventHandlerImpl(
      {
        action: act_1972474632001399_reloadSlickgrid_8030,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1972474632001399_request_8026 = new actions.RequestAction(
      {
        actionArgs: this.act_1972474632001399_request_8026_getActionArgs,
        displayName: "lock",
        events: [evh_1972474632001399_success_8027, evh_1972474632001399_success_8029],
      }
    );
    const evh_1972474632001399_clickPreventStop_8025 = new actions.EventHandlerImpl(
      {
        action: act_1972474632001399_request_8026,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_1972474632001399_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1972474632001399_clickPreventStop_8025],
      }
    );
    const act_2383909669375364_emit_8034 = new actions.EmitAction(
      {
        actionArgs: this.act_2383909669375364_emit_8034_getActionArgs,
        events: [],
      }
    );
    const evh_2383909669375364_success_8033 = new actions.EventHandlerImpl(
      {
        action: act_2383909669375364_emit_8034,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2383909669375364_reloadSlickgrid_8036 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2383909669375364_reloadSlickgrid_8036_getActionArgs,
        events: [],
      }
    );
    const evh_2383909669375364_success_8035 = new actions.EventHandlerImpl(
      {
        action: act_2383909669375364_reloadSlickgrid_8036,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2383909669375364_request_8032 = new actions.RequestAction(
      {
        actionArgs: this.act_2383909669375364_request_8032_getActionArgs,
        displayName: "lock",
        events: [evh_2383909669375364_success_8033, evh_2383909669375364_success_8035],
      }
    );
    const evh_2383909669375364_clickPreventStop_8031 = new actions.EventHandlerImpl(
      {
        action: act_2383909669375364_request_8032,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_2383909669375364_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2383909669375364_clickPreventStop_8031],
      }
    );
    const act_2342151935932928_emit_8040 = new actions.EmitAction(
      {
        actionArgs: this.act_2342151935932928_emit_8040_getActionArgs,
        events: [],
      }
    );
    const evh_2342151935932928_success_8039 = new actions.EventHandlerImpl(
      {
        action: act_2342151935932928_emit_8040,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2342151935932928_reloadSlickgrid_8042 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2342151935932928_reloadSlickgrid_8042_getActionArgs,
        events: [],
      }
    );
    const evh_2342151935932928_success_8041 = new actions.EventHandlerImpl(
      {
        action: act_2342151935932928_reloadSlickgrid_8042,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2342151935932928_request_8038 = new actions.RequestAction(
      {
        actionArgs: this.act_2342151935932928_request_8038_getActionArgs,
        displayName: "lock",
        events: [evh_2342151935932928_success_8039, evh_2342151935932928_success_8041],
      }
    );
    const evh_2342151935932928_clickPreventStop_8037 = new actions.EventHandlerImpl(
      {
        action: act_2342151935932928_request_8038,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_2342151935932928_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2342151935932928_clickPreventStop_8037],
      }
    );
    const act_2498310591257107_emit_8044 = new actions.EmitAction(
      {
        actionArgs: this.act_2498310591257107_emit_8044_getActionArgs,
        events: [],
      }
    );
    const evh_2498310591257107_success_8043 = new actions.EventHandlerImpl(
      {
        action: act_2498310591257107_emit_8044,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_2498310591257107_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_2498310591257107_success_8043],
      }
    );
    return {
      act_8358196963355853_script_8016,
      evh_8358196963355853_input_8015,
      evh_8358196963355853_input,
      act_4576710983066270_emit_8018,
      evh_4576710983066270_clickPreventStop_8017,
      evh_4576710983066270_clickPreventStop,
      act_2124730035910225_emit_8022,
      evh_2124730035910225_success_8021,
      act_2124730035910225_reloadSlickgrid_8024,
      evh_2124730035910225_success_8023,
      act_2124730035910225_request_8020,
      evh_2124730035910225_clickPreventStop_8019,
      evh_2124730035910225_clickPreventStop,
      act_1972474632001399_emit_8028,
      evh_1972474632001399_success_8027,
      act_1972474632001399_reloadSlickgrid_8030,
      evh_1972474632001399_success_8029,
      act_1972474632001399_request_8026,
      evh_1972474632001399_clickPreventStop_8025,
      evh_1972474632001399_clickPreventStop,
      act_2383909669375364_emit_8034,
      evh_2383909669375364_success_8033,
      act_2383909669375364_reloadSlickgrid_8036,
      evh_2383909669375364_success_8035,
      act_2383909669375364_request_8032,
      evh_2383909669375364_clickPreventStop_8031,
      evh_2383909669375364_clickPreventStop,
      act_2342151935932928_emit_8040,
      evh_2342151935932928_success_8039,
      act_2342151935932928_reloadSlickgrid_8042,
      evh_2342151935932928_success_8041,
      act_2342151935932928_request_8038,
      evh_2342151935932928_clickPreventStop_8037,
      evh_2342151935932928_clickPreventStop,
      act_2498310591257107_emit_8044,
      evh_2498310591257107_success_8043,
      evh_2498310591257107_success,
      reload: act_4576710983066270_emit_8018,
      lock: act_2342151935932928_request_8038,
    }
  }
}

Vue.component("UcRegisterEntryHeader", UcRegisterEntryHeader);

</script>